import React, { useEffect, useRef, useState } from "react";
import { useOutsideAlerter } from "../../utils/hooks";

const Select = ({
  options,
  selectedOption,
  handelChange,
  placeholder,
  label,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef, ()=>{
    setIsOpen(false);
  });
  
  function headClick() {
    setIsOpen(!isOpen);
  }

  function changeSelection(newVal) {
    handelChange(newVal);
    close();
  }

  function close() {
    setIsOpen(false);
  }

  function getText() {
    if (!selectedOption || !options.length) {
      return placeholder;
    } else if (options.find((o) => o.value == selectedOption)) {
      return options.find((o) => o.value == selectedOption).label;
    }

    return placeholder;
  }

  return (
    <div ref={wrapperRef} className="select-box" onBlur={close}>
      <label>{label}</label>
      <div className="content-select">
        <div
          className={`select button-select${isOpen ? " open" : ""}${
            selectedOption ? " selected-option" : ""
          }`}
          onClick={headClick}
        >
          <h5>{getText()}</h5>
          <i className="icon icon-arrow-down-short"></i>
        </div>
        <ul className={`list-options${isOpen ? " open" : ""}`}>
          {options.map((option, index) => (
            <li
              className={`option${
                option.value == selectedOption ? " selected" : ""
              }`}
              onClick={() => changeSelection(option.value)}
              key={index}
            >
              <h5>{option.label}</h5>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Select;
